module.exports = __webpack_public_path__ + "static/media/SANCHOYCA_MENU-normal.32db7c3e.png";